"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APIconButton = _interopRequireDefault(require("../common/APIconButton/APIconButton"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _MarginTransferButton = _interopRequireDefault(require("../MarginTransferAssetModal/MarginTransferButton"));
require("./WalletNavItems.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var cryptoNavItemsClasses = (0, _cssClassesHelper.getBEMClasses)('wallet-nav-item');
var CryptoNavItems = /*#__PURE__*/function (_React$Component) {
  function CryptoNavItems() {
    var _this;
    _classCallCheck(this, CryptoNavItems);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CryptoNavItems, [].concat(args));
    _defineProperty(_this, "onSendClick", function () {
      _this.onBtnClick(true);
    });
    _defineProperty(_this, "onReceiveClick", function () {
      _this.onBtnClick(false);
    });
    _defineProperty(_this, "onBtnClick", function (isSend) {
      var _this$props = _this.props,
        openSendReceiveSidePane = _this$props.openSendReceiveSidePane,
        product = _this$props.product,
        isWithdrawDisabled = _this$props.isWithdrawDisabled;
      if (isSend && isWithdrawDisabled) return;
      openSendReceiveSidePane(isSend, product);
    });
    return _this;
  }
  _inherits(CryptoNavItems, _React$Component);
  return _createClass(CryptoNavItems, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        t = _this$props2.t,
        showIconButtonLabel = _this$props2.showIconButtonLabel,
        product = _this$props2.product,
        margin = _this$props2.margin,
        hasAccounts = _this$props2.hasAccounts;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !margin && /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
        iconName: 'receive',
        action: this.onReceiveClick,
        tooltipText: showIconButtonLabel ? null : t('Receive'),
        customClass: cryptoNavItemsClasses(),
        showLabel: showIconButtonLabel,
        isDisabled: !product.DepositEnabled || !hasAccounts,
        label: t('Receive')
      }), !margin && /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
        iconName: 'send',
        action: this.onSendClick,
        tooltipText: showIconButtonLabel ? null : t('Send'),
        customClass: cryptoNavItemsClasses(),
        showLabel: showIconButtonLabel,
        isDisabled: !product.WithdrawEnabled || product.rawBalance <= 0 || !hasAccounts,
        label: t('Send')
      }), /*#__PURE__*/_react["default"].createElement(_MarginTransferButton["default"], {
        productId: product.ProductId,
        showIconButtonLabel: showIconButtonLabel
      }));
    }
  }]);
}(_react["default"].Component);
CryptoNavItems.defaultProps = {
  showIconButtonLabel: true
};
CryptoNavItems.propTypes = {
  openSendReceiveSidePane: _propTypes["default"].func.isRequired,
  product: _propTypes["default"].shape({
    ProductId: _propTypes["default"].number,
    isDepositAllowed: _propTypes["default"].bool,
    isWithdrawAllowed: _propTypes["default"].bool,
    isMarginBalancesPage: _propTypes["default"].bool
  }),
  showIconButtonLabel: _propTypes["default"].bool,
  isWithdrawDisabled: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('user')(CryptoNavItems);